/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
import React, { useCallback, useState } from 'react';
import { withRenderFlag } from '@beef/react';
import { compose } from '@reduxjs/toolkit';
import { connect } from 'react-redux';

import {
  getFirstGalleryImage,
  getPageTitle,
  getPrice,
  getOldPrice,
  getProductIsPreorder,
  getIsOutOfStock,
  getPriceDiscount,
  getPromotionAvailable,
  isProductInBasketSelector, getPromotionId,
} from 'store/ProductDetails/selectors';
import {
  getBundlesListModel,
  getBundlesPriceWithoutPromotion,
  getBundlesDiscountPercent,
  Bundle,
} from 'store/ProductDetails/bundles/selectors';
import { getPreorderOrderButtonText } from 'store/ProductDetails/preorder/selectors';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import { SOURCES_NAMES } from 'store/common/basket/constants';
import {
  addToBasket,
  addBundleToBasket,
} from 'store/ProductDetails/common/actions';

import { FloatLayoutMobile } from './components/FloatLayoutMobile';

export type FloatCardType = {
  price: number,
  oldPrice: number,
  isPreorder: boolean,
  preorderButtonText: string,
  promotionAvailable: boolean,
  list: Bundle[],
  isInBasket: boolean,
  promotionId: number,
  bundleOldPrice: number,
  addToBasketItem: () => void,
  addBundleToBasketItem: () => void,
};

const FloatCard: React.FC<FloatCardType> = ({
  price,
  oldPrice,
  isPreorder,
  preorderButtonText,
  promotionAvailable,
  list,
  isInBasket,
  promotionId,
  bundleOldPrice,
  addToBasketItem,
  addBundleToBasketItem,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  const redirectToBasket = () => { window.location.href = '/basket/'; };

  const onPurchase = useCallback(
    () => {
      const options = {
        promotionId,
        origin: 'card',
        source: SOURCES_NAMES.PRODUCT_DETAILS_PAGE,
      };

      addToBasketItem(options);
    },
    [],
  );

  const onAddBundleToBasket = useCallback(
    () => {
      const dataForBundle = list[0]?.getActionData();
      addBundleToBasketItem(dataForBundle);
    },
    [list],
  );

  const onClick = useCallback(
    () => {
      if (isInBasket) {
        return redirectToBasket();
      }

      if (!!promotionAvailable && isChecked) {
        return onAddBundleToBasket();
      }

      onPurchase();
    },
    [
      redirectToBasket,
      onPurchase,
      onAddBundleToBasket,
      isChecked,
      promotionAvailable,
      list,
    ],
  );

  const onSetIsChecked = useCallback(() => setIsChecked(!isChecked), [isChecked]);
  const buttonTitle = isInBasket ? 'В корзине' : isPreorder ? preorderButtonText : 'В корзину';
  const bundlePrice = list[0]?.getPrice();
  const devicePrice = isChecked ? bundlePrice : price;
  const deviceOldPrice = isChecked ? bundleOldPrice : oldPrice;

  return (
    <FloatLayoutMobile
      isInBasket={isInBasket}
      price={devicePrice}
      oldPrice={deviceOldPrice}
      isChecked={isChecked}
      buttonTitle={buttonTitle}
      promotionAvailable={promotionAvailable}
      onSetIsChecked={onSetIsChecked}
      onBuyClick={onClick}
    />
  );
};

const mapStateToProps = state => ({
  title: getPageTitle(state),
  imageUrl: (getFirstGalleryImage(state) || {}).imageUrl,
  price: getPrice(state),
  oldPrice: getOldPrice(state),
  discount: getPriceDiscount(state),
  isPreorder: getProductIsPreorder(state),
  preorderButtonText: getPreorderOrderButtonText(state),
  promotionAvailable: getPromotionAvailable(state),
  list: getBundlesListModel(state),
  isInBasket: isProductInBasketSelector(state),
  promotionId: getPromotionId(state),
  isMobile: isScreenBelow800(state),
  shouldRender: isScreenBelow800(state),
  bundleOldPrice: getBundlesPriceWithoutPromotion(state),
  bundleDiscount: getBundlesDiscountPercent(state),
  isOutOfStock: getIsOutOfStock(state),
});

const mapDispatchToProps = {
  addToBasketItem: addToBasket,
  addBundleToBasketItem: addBundleToBasket,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRenderFlag,
)(FloatCard);
